var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { cloneElement, useEffect, useMemo, useRef } from "react";
import ReactDOM from "react-dom";
import { useMediaQuery } from "react-responsive";
import { Flex } from "rebass";
import { breakpoints } from "src/styles/theme";
import styled from "styled-components";
var getWidth = function (width) {
    if (!width) {
        return "auto";
    }
    var widths = [];
    if (!Array.isArray(width)) {
        return "0 0 ".concat(width * 100, "%");
    }
    width.forEach(function (value) {
        widths.push("0 0 ".concat(value * 100, "%"));
    });
    return widths;
};
export var Grid = function (_a) {
    var ml = _a.ml, flexWrap = _a.flexWrap, others = __rest(_a, ["ml", "flexWrap"]);
    return (React.createElement(Flex, __assign({ ml: ml || -2, flexWrap: flexWrap || "wrap" }, others)));
};
export var Col = function (_a) {
    var width = _a.width, flex = _a.flex, pl = _a.pl, others = __rest(_a, ["width", "flex", "pl"]);
    return (React.createElement(Flex, __assign({ pl: pl || 2, flex: flex || getWidth(width) }, others)));
};
export var StickyContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  padding: ", " 1rem 1rem 1rem;\n  background: ", ";\n  box-shadow: ", ";\n  display: ", ";\n"], ["\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  padding: ", " 1rem 1rem 1rem;\n  background: ", ";\n  box-shadow: ", ";\n  display: ", ";\n"])), function (props) { return props.top; }, function (props) { return (props.isSticky ? "1rem" : "0"); }, function (props) { return (props.isSticky ? "white" : "transparent"); }, function (props) {
    return props.isSticky ? "0 0 10px 0 rgba(0, 0, 0, 0.1)" : "none";
}, function (props) { return (props.hidden ? "none" : "block"); });
export var StickyHeader = function (_a) {
    var wrapper = _a.wrapper, children = _a.children;
    var isMobile = useMediaQuery({ query: "(max-width: ".concat(breakpoints.md, ")") });
    var _b = React.useState(false), isSticky = _b[0], setIsSticky = _b[1];
    var _c = React.useState(0), top = _c[0], setTop = _c[1];
    var childrenRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    var height = useRef(0);
    useEffect(function () {
        var _a;
        var wrapperRect = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        setTop((wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.top) <= 9 ? 0 : wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.top);
    }, [wrapperRef.current]);
    useEffect(function () {
        var handleScroll = function () {
            var _a;
            if (!childrenRef.current)
                return;
            var wrapperRect = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            var shouldBeSticky = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.top) <= 9;
            setTop((wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.top) <= 9 ? 0 : wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.top);
            if (shouldBeSticky !== isSticky) {
                setIsSticky(shouldBeSticky);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function () { return window.removeEventListener("scroll", handleScroll); };
    }, [isSticky]);
    var element = useMemo(function () {
        return cloneElement(wrapper, { ref: childrenRef }, children);
    }, [children, wrapper]);
    useEffect(function () {
        if (childrenRef.current) {
            height.current = childrenRef.current.clientHeight;
        }
    }, [childrenRef.current]);
    return (React.createElement(React.Fragment, null, isMobile ? (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: wrapperRef, style: { height: "".concat(height.current, "px") } }),
        ReactDOM.createPortal(React.createElement(StickyContainer, { isSticky: isSticky, top: top }, element), document.body))) : (element)));
};
var templateObject_1;
